<template>
  <div id="ebook">
    <div class="page" v-if="currentPage.width && currentPage.height">
      <svg :viewBox="'0 0 ' + currentPage.width + ' ' + currentPage.height">
        <template v-for="action in currentPage.actions">
          <template v-for="region in action.clickRegions">
            <polygon :points="toPointString(region.points)" @click="playAudioFile(action.mediaPath, action.mtc)"></polygon>
          </template>
        </template>
      </svg>
      <img :src="currentPage.path" width="100%" />
      <span class="page-left" @click="pageLeft()" v-if="page > 1">
        <i class="fas fa-chevron-left"></i>
      </span>
      <span class="page-right" @click="pageRight()" v-if="page < pages.length">
        <i class="fas fa-chevron-right"></i>
      </span>
    </div>

    <nav class="mt-3" aria-label="Page navigation">
      <span class="float-left" v-if="pdf">
        <a :href="pdf" class="btn btn-sm btn-primary" download>檔案下載</a>
      </span>
      <ul class="pagination justify-content-end">
        <li class="page-item"
          v-for="n in pages.length"
          :class="{ 'active': page === n }">
          <a class="page-link" @click="page = n">{{ n }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import audioPlayerMixin from './mixins/audioPlayerMixin.js'
  // import fontawesome from '../../node_modules/@fortawesome/fontawesome'
  // import { faChevronLeft, faChevronRight } from '../../node_modules/@fortawesome/fontawesome-free-solid'

  // fontawesome.library.add(faChevronLeft)
  // fontawesome.library.add(faChevronRight)

  export default {

    name: 'Ebook',

    mixins: [audioPlayerMixin],

    props: {
      data: {
        type: Object,
        required: true,
        default: () => {
          return {}
        }
      }
    },

    data () {
      return {
        pages: [],
        pdf: null,
        page: 1
      }
    },

    computed: {
      currentPage () {
        return this.pages[this.page - 1]
      }
    },

    created () {
      this.pages = this.data.pages
      this.pdf = this.data.pdf
      this.$watch('page', (val, oldVal) => {
        this.audio && this.audio.pause()
      })
    },

    beforeMount () {
      window.addEventListener('keyup', this.handleKeyup)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.handleKeyup)
    },

    methods: {
      toPointString (region) {
        let point = ''
        region.forEach((e) => {
          point += e.x + ',' + e.y + ' '
        })

        return point.replace(/\s+$/g, '')
      },

      handleKeyup (evt) {
        if (evt.keyCode === 37) {
          this.pageLeft()
        } else if (evt.keyCode === 39) {
          this.pageRight()
        }
      },

      pageLeft () {
        this.page = this.page - 1 > 0 ? this.page - 1 : this.page
      },

      pageRight () {
        this.page = this.page + 1 <= this.pages.length ? this.page + 1 : this.page
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/style/app.scss';

  #ebook {
    .page {
      border: 1px #ccc solid;
      position: relative;

      img {
        width: 100%;
      }

      svg {
        position: absolute;
        width: 100%;
        height: 100%;

        polygon {
          cursor: pointer;
          fill: $light;
          fill-opacity: 0;

          &:hover {
              fill-opacity: 0.2;
          }
        }
      }

      .page-left, .page-right {
        position: absolute;
        top: 50%;
        width: 3em;
        height: 3em;
        cursor: pointer;

        opacity: 0.6;
        filter: alpha(opacity=60);

        :hover {
          opacity: 1;
          filter: alpha(opacity=100);
        }

        svg {
          opacity: 0.6;
          filter: alpha(opacity=60);

          :hover {
            opacity: 1;
            filter: alpha(opacity=100);
          }
        }
      }

      .page-left {
        left: 0;
      }

      .page-right {
        right: 0;
      }
    }

    .page-item {
      cursor: pointer;

      &.active {
        .page-link {
          background-color: $normal;
          border-color: $normal;
        }
      }

      &:hover {
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Ebook.vue?1ab11634